import type { FC } from "react";
import { Suspense, lazy } from "react";

import { SkeletonEditPasswordPage } from "./SkeletonEditPasswordPage";
const EditPasswordPage = lazy(() => import("./EditPasswordPageDefault"));

const LazyEditPasswordPage: FC = () => {
  return (
    <Suspense fallback={<SkeletonEditPasswordPage />}>
      <EditPasswordPage />
    </Suspense>
  );
};

export { LazyEditPasswordPage };
